import { functions } from '../config/firebase';

import { httpsCallable } from 'firebase/functions';

/*
 * Sends an email to the QCrypt mailing list
 */
export function sendEmail(
  newEmail: string,
  newName: string,
  newMessage: string,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const createUserCloudFunction = httpsCallable(functions, 'sendEmail');

    createUserCloudFunction({
      email: newEmail,
      name: newName,
      message: newMessage,
    })
      .then(async () => {
        resolve();
      })
      .catch((error) => {
        console.log(error);
        reject();
      });
  });
}
